// extracted by mini-css-extract-plugin
export default {"header":"X44_1UXLkScV8ldBdjaK"};